export const appVersion = { version: '3118578' };
